import encodeurl from 'encodeurl';
import { updateLibraryCreative as updateCreative } from 'modules/creative-library/flows';

export const updateLibraryCreative = (newValue, creative) => dispatch => {
    const { accountName, id: creativeId } = creative;
    const { url } = newValue;
    const savedValue = url ? { ...newValue, url: encodeurl(url) } : newValue;
    dispatch(updateCreative(accountName, creativeId, savedValue));
};
